<template>
  <v-card v-if="showCbteAsociado()" elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Comprobante asociado</h6>
      <p class="text-body-2">Seleccione el comprobante que desea asociar</p>

      <v-row>
        <v-col cols="12" md="8">
          <v-combobox
            :disabled="isViewModal || invoice_to_cancel != null || invoice.id > 0 || loading_voucher || !invoice.emitter"
            v-model="selected_voucher"
            data-vv-as="Comprobante"
            name="voucher_to_associate"
            :item-text="voucher_name"
            item-value="id"
            :items="vouchers_available"
            label="Seleccione un comprobante para asociar"
            autocomplete="off"
            :loading="loading_voucher"
            clearable
            @change="onVoucherSelected"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ !invoice.emitter ? "Primero seleccione un emisor" : "No hay comprobantes disponibles para asociar" }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="12" md="4" class="pt-1" v-if="vouchersService.isElectronicVoucher(invoice.cbte_tipo)">
          <v-combobox
            :disabled="isViewModal"
            v-model="comprobante_asociado.anulacion"
            data-vv-as="Motivo"
            name="anulacion"
            item-text="name"
            item-value="id"
            v-validate="'combobox'"
            :items="[
              { id: 'N', name: 'Anulación' },
              { id: 'S', name: 'Rechazo' },
            ]"
            label="Motivo"
            autocomplete="off"
            class="overflow-auto"
            filled
            clearable
          ></v-combobox>
          <span class="red--text">{{ errors.first("anulacion") }}</span>
        </v-col>
      </v-row>

      <!-- Mostrar comprobante asociado si existe -->
      <v-row v-if="invoice.cbte_asoc && invoice.cbte_asoc.length > 0">
        <v-col cols="12">
          <v-chip
            v-for="(cbte, index) in invoice.cbte_asoc"
            :key="index"
            class="ma-2"
            color="primary"
            outlined
            :close="!isViewModal && invoice.id == 0"
            @click:close="removeAssociation(index)"
            :close-disabled="isViewModal || invoice_to_cancel != null || invoice.id > 0"
          >
            <v-icon left small>mdi-file-document</v-icon>
            {{ cbte.voucher_number_label }} - {{ formatUtils.formatPrice(cbte.imp_total) }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { vouchersService } from "@/libs/ws/vouchersService";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: {},
  props: {
    invoice: Object,
    invoice_to_cancel: Object,
    loading_combos: Object,
    comprobante_asociado: Object,
    loading_voucher_asociado: Boolean,
    error_search_cbte_asociado: Boolean,
    searchCbteAsociado: Function,
    validator: Object,
    isViewModal: { type: Boolean, default: false },
  },
  data: () => ({
    formatUtils: formatUtils,
    vouchersService: vouchersService,
    vouchers_available: [],
    selected_voucher: null,
    loading_voucher: false,
    emitter_selected: null,
  }),
  watch: {
    invoice: {
      handler: function (newValue) {
        if (newValue == null) {
          return;
        }

        // Cargar comprobantes pendientes cuando cambia el emisor
        if ((this.emitter_selected == null && newValue.emitter != null) || (newValue.emitter != null && this.emitter_selected != null && this.emitter_selected.id != newValue.emitter.id)) {
          this.emitter_selected = newValue.emitter;
          this.loadPendingVouchers();

          // Limpiar selección si no viene de invoice_to_cancel
          if (this.invoice_to_cancel == null && (!this.invoice.cbte_asoc || this.invoice.cbte_asoc.length === 0)) {
            this.selected_voucher = null;
            this.comprobante_asociado.anulacion = null;
            this.errors.clear();
            this.validator.reset();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // Cargar comprobantes pendientes si ya hay emisor seleccionado
    if (this.invoice && this.invoice.emitter) {
      this.emitter_selected = this.invoice.emitter;
      this.loadPendingVouchers();
    }
  },
  methods: {
    voucher_name: (item) =>
      item.id != 0 ? formatUtils.formatDateString(item.cbte_fch) + " - " + item.voucher_number_label + " - (" + formatUtils.formatPrice(item.imp_total) + ")" : item.voucher_number_label,
    loadPendingVouchers() {
      if (!this.invoice || !this.invoice.emitter) {
        this.vouchers_available = [];
        return;
      }

      this.loading_voucher = true;
      const params = {
        emitter: this.invoice.emitter.id,
      };

      if (this.invoice.receiver && this.invoice.receiver.id > 0) {
        params.receiver_id = this.invoice.receiver.id;
      }

      vouchersService
        .getPendingVouchers(params)
        .then((response) => {
          if (response.status) {
            // Filtrar los comprobantes que ya están asociados
            const associatedIds = (this.invoice.cbte_asoc || []).map((cbte) => cbte.id);
            this.vouchers_available = response.result.filter((voucher) => !associatedIds.includes(voucher.id));
          } else {
            this.vouchers_available = [];
          }
        })
        .catch((e) => {
          console.log("getPendingVouchers error", e);
          this.vouchers_available = [];
        })
        .finally(() => {
          this.loading_voucher = false;
        });
    },
    onVoucherSelected() {
      if (!this.selected_voucher || this.selected_voucher.id == 0) {
        return;
      }

      // Agregar el comprobante seleccionado a invoice.cbte_asoc
      if (!this.invoice.cbte_asoc) {
        this.invoice.cbte_asoc = [];
      }

      // Verificar que no esté ya agregado
      const exists = this.invoice.cbte_asoc.find((cbte) => cbte.id === this.selected_voucher.id);
      if (exists) {
        this.$toast.warning("El comprobante ya está asociado");
        this.selected_voucher = null;
        return;
      }

      // Para notas de crédito/débito, solo permitir un comprobante asociado
      if (this.invoice.cbte_asoc.length > 0 && this.invoice.cbte_tipo && !vouchersService.VoucherList().includes(this.invoice.cbte_tipo.Id)) {
        this.$toast.warning("Solo se puede asociar un comprobante");
        this.selected_voucher = null;
        return;
      }

      // Agregar el comprobante
      this.invoice.cbte_asoc.push(this.selected_voucher);

      // Remover de la lista de disponibles
      const index = this.vouchers_available.findIndex((v) => v.id === this.selected_voucher.id);
      if (index > -1) {
        this.vouchers_available.splice(index, 1);
      }

      this.$toast.success("Comprobante agregado correctamente");
      this.selected_voucher = null;
    },
    removeAssociation(index) {
      if (this.isViewModal || this.invoice_to_cancel != null || this.invoice.id > 0) {
        return;
      }

      const removedVoucher = this.invoice.cbte_asoc[index];
      this.invoice.cbte_asoc.splice(index, 1);

      // Agregar de vuelta a la lista de disponibles
      if (removedVoucher && removedVoucher.id) {
        this.vouchers_available.push(removedVoucher);
      }

      // Limpiar anulacion si no hay más comprobantes
      if (this.invoice.cbte_asoc.length === 0) {
        this.comprobante_asociado.anulacion = null;
      }

      this.$toast.info("Comprobante desasociado");
    },
    showCbteAsociado() {
      if (this.invoice == null || (this.invoice != null && this.invoice.cbte_tipo == null)) {
        return false;
      }
      return !vouchersService.VoucherList().includes(this.invoice.cbte_tipo.Id);
    },
  },
};
</script>
